import { defineComponent, inject, onUnmounted, ref, getCurrentInstance } from 'vue'
import { useAppStore } from '@/pages/chargermap/stores/app'
import { Auth } from '@loca/mfe-utils'
import 'vant/lib/index.css'
// import '@/css/fonts.css' // 使用了useFontFamily，不需要再引入
import Tracker from '@nio-fe/nio-tracker-web'
import RouterView, { router } from './router'
import '@nio-pow/h5-components/dist/style.css' // h5-components组件样式
import NSH5 from './nsh5' // Import the NSH5 component
import { useBus } from './boot/bus'
import { useFontFamily } from '@nio-fe/horo-h5'
import { isInMiniProgram } from './utils/acrossAgent'
import { initUniversalFun } from '@/utils/initMiniProgramBridge'
import { nioJsBridge } from '@nio-wad/universal-bridge-h5'
export { router } // 不能删除，否则会导致路由跳转失败
import { HButton } from '@nio-fe/horo-h5'
import styles from './styles.module.scss'
import { NioApmPlus } from '@nio-fe/nio-apm-plus'
import { getEnv } from '@nio-wad/hooks'
// horo-ui 引入当前品牌的样式文件
require(`@nio-fe/horo-h5/dist/style${
  (process.config as { [key: string]: any }).brand === 'nio'
    ? ''
    : '.' + (process.config as { [key: string]: any }).brand
}.css`)
require(`./theme/style.${(process.config as { [key: string]: any }).brand}.scss`)

export default defineComponent({
  name: 'App',
  props: [],
  setup: () => {
    if (window.location.hash.startsWith('#/access/denied')) {
      return () => <RouterView />
    }

    const env = getEnv();
    console.log('====================================');
    console.log('env--main',env);
    console.log('====================================');
    // 根应用实例由 page-boot-loader 创建；此处取当前组件所在 Application，供 APM 等使用
    const app = getCurrentInstance()!.appContext.app
    const apmInstance = NioApmPlus.createDefaultInstanceSync({
      plugins: {
          pageview: {
              routeMode: 'history',
          },
          vueErrorHandler: {
              app: app as any,
          },
      },
      serviceEnv: env === 'local' || env === 'dev' ? 'test' : env,
      serviceName: 'pe-h5pages-fe',
    });
    console.log('====================================');
    console.log('apmInstance',apmInstance);
    console.log('====================================');

    useFontFamily(
      (process.config as any).fontFamily.locale,
      (process.config as any).fontFamily.token
    )
    const initMiniWs = async () => {
      if (isInMiniProgram()) {
        await initUniversalFun()
        nioJsBridge.hideLoading({})
      }
    }
    initMiniWs()
    const bus = useBus()
    const appStore = useAppStore()
    const channel = inject<string>('channel', '')
    const client = inject<string>('client', '')
    const userToken = Auth.getAccessToken() // 用户账号token
    const pageStartTime = new Date().getTime()
    const trackParamsCommon = {
      platid: client,
      adsourceid: channel,
      userToken: userToken,
    }

    /**
     * 竖屏状态下添加body-vertical类名，横屏状态下添加body-horizontal类名
     */
    const applyClassToBody = () => {
      if (client === 'mobile') {
        window.screen_orientation = 'vertical'
        document.body.classList.remove('body-horizontal')
        document.body.classList.add('body-vertical')
      } else {
        window.screen_orientation = 'horizontal'
        document.body.classList.remove('body-vertical')
        document.body.classList.add('body-horizontal')
      }
      // 因为在官网中导航是悬浮状态所以要自定义样式
      if (window.attr === 'firefly') {
        document.body.classList.add('body-firefly')
      }
    }
    applyClassToBody()

    // 来源埋点
    Tracker.track('nsh5_nationalmap', trackParamsCommon)
    appStore.$patch({
      trackParamsCommon: trackParamsCommon,
      pageStartTime: pageStartTime,
    })

    const dictionaryState = ref<string>('loading')
    const getDictionaries = () => {
      appStore.getConfigs().then((res) => {
        dictionaryState.value = res
      })
    }
    getDictionaries()

    onUnmounted(() => {
      bus.off('*')
    })
    return () => (
      <>
        {client === 'mobile' && dictionaryState.value === 'error' ? (
          // error page
          <div class={styles.errorPage}>
            <img src="https://cdn-fx.nio.com/fx/pe-h5pages-fe/__cdn__/map_bg.png" alt="" />
            <p>地图开小差了，请稍后再试</p>
            <HButton
              round
              onClick={getDictionaries}
              style={{
                width: '86px',
              }}
            >
              刷新
            </HButton>
          </div>
        ) : (
          <NSH5></NSH5>
        )}
      </>
    )
  },
})
